export enum CommonColumn {
  Select = 'select',
  Favorite = 'favorite',
  DataQualityIndicator = 'dataqualityindicator',
  ContentType = 'contentype',
  Name = 'name',
  ProjectsCount = 'projectscount',
  WorkbooksCount = 'workbookscount',
  Hits = 'hitsCol',
  ViewsCount = 'viewscount',
  SheetsCount = 'sheetscount',
  SheetsCountInCrass = 'sheetscountcrass',
  Workbook = 'workbook',
  DatasourcesCount = 'datasourcescount',
  Size = 'size',
  SheetNumber = 'sheetnumber',
  DatasourceInWorkbooksCount = 'datasourceinworkbookscount',
  ConnectsTo = 'connectsto',
  Project = 'project',
  Owner = 'owner',
  Created = 'created',
  Modified = 'modified',
  ModifiedBy = 'modifiedBy',
  ExtractStatus = 'extractstatus',
  ExtractStatusOnly = 'extractstatusonly',
  Alert = 'alert',
  ConnectionType = 'connectiontype',
  Authentication = 'authentication',
  Username = 'username',
  Datasource = 'datasource',
  RunNextAt = 'nextUpdate',
  Status = 'status',
  Priority = 'priority',
  TaskType = 'taskType',

  // Subscriptions
  Subject = 'subject',
  UsernameForSubscription = 'usernameForSubscription',
  SubscribedTo = 'subscribedTo',
  Schedule = 'schedule',
  SubscribedBy = 'subscribedBy',
  LastUpdate = 'lastUpdate',
  LastRunAt = 'lastRunAt',
  RunNextAtSubscription = 'nextUpdate',

  // Extract tasks
  WorkbookDatasourceName = 'workbookDatasourceName',
  RemoteRefreshType = 'remoteRefreshType',
  Definition = 'definition',
  RemoteRefreshPriority = 'remoteRefreshPriority',
  State = 'state',

  // recents
  LastAccessedAt = 'lastAccessedAt',

  // Flow Run History
  FlowName = 'flowName',
  OutputStep = 'outputStep',
  OutputSteps = 'outputSteps',
  RunType = 'runType',
  RunStartedAt = 'runStartedAt',
  RunEndedAt = 'runEndedAt',
  RunDuration = 'runDuration',
  RunStatus = 'runStatus',
  RunRowsProduced = 'runRowsProduced',
  RunErrors = 'runErrors',
  RunFlowTasksStatus = 'runFlowTasksStatus',
  LastRunAtFlows = 'lastRunAtFlows',
  RunNextAtFlows = 'runNextAtFlows',
  FlowFileType = 'fileType',

  // Jobs
  Id = 'id',
  BackgroundJobType = 'BackgroundJobType',
  BackgroundJobPriority = 'BackgroundJobPriority',
  ContentOwner = 'contentOwner',
  JobRequestedTime = 'jobRequestedTime',
  CurrentRunTime = 'currentRunTime',
  CurrentQueueTime = 'currentQueueTime',
  AverageRunTime = 'averageRunTime',
  AverageQueueTime = 'averageQueueTime',

  //Metrics
  MetricValue = 'metricValue',
  MetricConnectedView = 'metricConnectedView',
  MetricUpdated = 'metricUpdated',

  // Data Alerts
  DataAlertSubject = 'dataAlertSubject',
  DataAlertView = 'dataAlertView',
  DataAlertRecepient = 'dataAlertRecepient',
  DataAlertVisibleTo = 'dataAlertVisibleTo',
  DataAlertEmailSent = 'dataAlertEmailSent',
  DataAlertLastChecked = 'dataAlertLastChecked',
  DataAlertLast = 'dataAlertLast',

  // Site
  SiteNameLink = 'linkSiteName',
  SiteUserCount = 'siteUserCount',
  SiteAdminCount = 'siteAdminCount',
  SiteUserQuota = 'siteUserQuota',
  SiteStorageUsed = 'siteStorageUsed',
  SiteStorageQuota = 'siteStorageQuota',
  SiteStatus = 'siteStatus',
  SiteMetricsEnabled = 'siteMetricsEnabled',
  SiteAuthoringEnabled = 'siteAuthoringEnabled',
  SiteSheetImageEnabled = 'siteSheetImageEnabled',
  SiteEditMembership = 'siteEditMembership',
  SiteExtractEncryption = 'siteExtractEncryption',
  SiteGuestAccessEnabled = 'siteGuestAccessEnabled',
  SiteAskDataMode = 'siteAskDataMode',

  // Schedules
  ScheduleName = 'scheduleName',
  ScheduleFrequency = 'scheduleFrequency',
  ScheduleTaskType = 'scheduleTaskType',
  ScheduleTasks = 'scheduleTasks',
  ScheduleExecution = 'scheduleExecution',
  ScheduleNextRunAt = 'scheduleNextRunAt',
  SiteName = 'siteName',

  // Groups
  GroupName = 'groupName',
  GroupDomain = 'groupDomain',
  GroupUserCount = 'groupUserCount',
  GroupMinSiteRole = 'groupMinSiteRole',
  GroupLicenseOnSignIn = 'groupLicenseOnSignin',

  // Site Users
  SiteUserName = 'siteUserName',
  SiteUserRole = 'siteUserRole',
  SiteUserGroupCount = 'siteUserGroupCount',
  SiteUserLastSignin = 'siteUserLastSignin',
  SiteUserDomainName = 'siteUserDomainName',
  SiteUserAuthentication = 'siteUserAuthentication',
  SiteUserDisplayName = 'siteUserDisplayName',

  // Server Users
  ServerUserDisplayName = 'serverUserDisplayName',
  ServerUserMaxSiteRole = 'serverUserMaxSiteRole',
  ServerUserLicenseLevel = 'serverUserLicenseLevel',
  ServerUserSiteCounts = 'serverUserSiteCounts',

  // Users (only used in search)
  UserDisplayName = 'userDisplayName',
  UserOwnedViewsCount = 'userOwnedViewsCount',
  UserOwnedWorkbooksCount = 'userOwnedWorkbooksCount',
  UserOwnedDatasourcesCount = 'userOwnedDatasourcesCount',

  // Collections
  CollectionItemCount = 'collectionItemCount',
  CollectionVisibility = 'collectionVisibility',
}
